import React from "react";
import { useTranslation } from "react-i18next";
import { useScanQrcodeStore } from "@/store";
import { isEmpty } from "@/utils";

const CommonFooter: React.FC = () => {
  const { t } = useTranslation();
  const { company } = useScanQrcodeStore();

  if (isEmpty(company) || !company.is_show_address) {
    return null;
  }

  return (
    <footer className="bg-gray-100 p-4 mt-3">
      <div className="text-sm text-gray-600 mb-2">
        <p className="font-bold">{t("common.help_contact")}</p>
        {company?.address && <p className="text-[#14272B]">{company.address}</p>}
        {company?.phone && (
          <p className="text-[#14272B]">
            {t("common.phone")}: {company.phone}
          </p>
        )}
        {company?.email && (
          <p className="text-[#14272B]">
            {t("common.email")}: {company.email}
          </p>
        )}
      </div>
    </footer>
  );
};

export default CommonFooter;
